import React, { FC, ReactNode, ChangeEvent } from 'react'
import { useId } from '@reach/auto-id'
import cx from 'classnames'
import { Text } from 'components/Text'
import { Icon } from 'components/Icon'
import styles from './Checkbox.module.scss'

type CheckboxProps = {
  id?: string
  label: ReactNode
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  checked: boolean
  value?: string
  name?: string
  disabled?: boolean
  children?: ReactNode
  required?: boolean
  className?: string
  size?: 'small'
}

export const Checkbox: FC<CheckboxProps> = ({
  children,
  id,
  label,
  className = '',
  size = '',
  ...rest
}) => {
  const checkboxId = useId(id)
  const classes = cx({
    [styles.checkbox]: true,
    [styles[size]]: size,
    [className]: className,
  })

  return (
    <div className={classes}>
      <input type="checkbox" id={checkboxId} {...rest} />

      <Icon name="check-line" className={styles.check} />

      <Text component="label" htmlFor={checkboxId} className={styles.label}>
        {label}
      </Text>

      {children}
    </div>
  )
}

Checkbox.displayName = 'Checkbox'
